import React from 'react';
// eslint-disable-next-line react/no-deprecated
import { render } from 'react-dom';
import SearchBarContainer from './containers/search-bar';
import ResultsList from './containers/app';
import { setApplicationVariables } from './utils/interface';

import './utils/polyfills';
import './index.css';

const defaultResultListId = '#search-results';
const defaultSearchBarTarget = '#search-bar';
const resultsListTarget = document.querySelector(defaultResultListId);
const searchBarTarget = document.querySelector(defaultSearchBarTarget);

const renderResultsList = (target = resultsListTarget, props = {}) => {
  target &&
    true &&
    render(
      <ResultsList
        app={props.app}
        env={props.env}
        dev={props.dev === 'true' || false}
        ga={props.ga}
        gaDebug={props.gaDebug === 'true' || false}
      />,
      target,
    );
};

const renderSearchBar = (target = searchBarTarget, props = {}) => {
  target &&
    render(
      <SearchBarContainer
        app={props.app}
        env={props.env}
        dev={props.dev === 'true' || false}
        redirectType={props.redirectType}
        searchRedirect={props.searchRedirect}
      />,
      target,
    );
};

const search = {
  init(target, props) {
    setApplicationVariables(props);
    renderResultsList(target, props);
  },
};

const searchBar = {
  init(target, props) {
    setApplicationVariables(props);
    renderSearchBar(target, props);
  },
};

window.searchBar = searchBar;
window.search = search;

if (resultsListTarget) {
  search.init();
}

if (searchBarTarget) {
  searchBar.init();
}
